import React from 'react';
import { SectionHeading, SectionHeadingProps } from '../../molecules/SectionHeading';

type ListProps = {
  headingSpecs: SectionHeadingProps;
  children: React.ReactNode;
  cardWidth?: {
    mobile: string;
    sm: string;
    lg: string;
  };
};

export default function List({ headingSpecs, children, cardWidth }: ListProps) {
  const { sectionTitle, linkText, onClick, href, subheading } = headingSpecs;

  const defaultCardWidth = {
    mobile: 'w-[156px]',
    sm: 'sm:w-64',
    lg: 'lg:w-[364px]',
  };

  const widthClasses = cardWidth || defaultCardWidth;

  return (
    <div>
      <div className="px-2 sm:px-4 lg:px-16">
        <SectionHeading
          sectionTitle={sectionTitle}
          {...(linkText && { linkText })}
          {...(onClick && { onClick })}
          {...(href && { href })}
          {...(subheading && { subheading })}
        />
      </div>

      <div className="relative mt-6">
        <div className="relative w-full overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <div className="inline-flex space-x-4 pl-2 sm:space-x-6 sm:pl-4 lg:space-x-8 lg:pl-16">
            {React.Children.map(children, (child) => (
              <div className={`inline-flex flex-col ${widthClasses.mobile} ${widthClasses.sm} ${widthClasses.lg}`}>
                {child}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
